

































import Breadcrumb from "@/components/Breadcrumb/index.vue";
import Hamburger from "@/components/Hamburger/index.vue";
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
// import { UserModule } from "@/store/modules/user";
import Cookies from "js-cookie";

@Component({
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class Navbar extends Vue {
  get sidebar() {
    return AppModule.sidebar;
  }

  get avatar() {
    // return UserModule.avatar;
    return '';
  }

  get username() {
    return '';
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }

  private logout() {
    // UserModule.LogOut().then(() => {
    //   location.reload(); // 为了重新实例化vue-router对象 避免bug
    // });
  }
}
